"use client";
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import Image from 'next/image';
import { LIGHT_DOWNLOAD_ANDROID, IS_WECHAT, IS_IOS } from '@/constants';
import SmartIcon from '@/components/SmartIcon';
import DownloadHint from '@/components/DownloadHint';
import { getIOSDownloadUrl } from '@/constants/channelDownload';
import { getParamsFromUrl } from '@/utils';
import styles from './index.module.scss';

import LOGO  from '@/public/assets/images/logo.png';

const OutsideDownloadContainer = () => {
  const [showDownloadHint, setShowDownloadHint] = useState(false);

  const onAndroidDownloadClick = (e) => {
    if (IS_WECHAT && !IS_IOS) {
      e.preventDefault();
      setShowDownloadHint(true);
    }
  };

  const onDownloadHintCallback = () => {
    setShowDownloadHint(false);
  };

  const from = getParamsFromUrl('from');

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <div className={styles.section}>
          <div className={styles.description}>
            <div className={styles.appContainer}>
              <div className={styles.logo}>
                <Image 
                  layout="fill"
                  src={LOGO.src}
                  objectFit="cover"
                  alt="app logo"
                />
              </div>
              <div className={styles.appSlogn}>
                <FormattedMessage tagName="h2" id="common:light.name" />
                <FormattedMessage tagName="h3" id="common:light.slogn" />
              </div>
            </div>
            <div className={styles.appDescription}>
              <FormattedMessage id="common:light.description">
                {
                  (str) => {
                    const txts = str[0].split('&#13;');
                    return txts.map(t => <div key={t}>{t}</div>);
                  }
                }
              </FormattedMessage>
            </div>
            <div className={styles.downloadContainer}>
              <a
                href={ IS_IOS ? getIOSDownloadUrl(from) : LIGHT_DOWNLOAD_ANDROID }
                className={styles.downloadIcon}
                onClick={onAndroidDownloadClick}
                target="_blank"
                rel="noreferrer noopener"
              >
                <div className={cx(styles.downloadIcon, {[styles.appStoreIcon] : IS_IOS})}>
                  <SmartIcon icon={IS_IOS ? "app_store_download" : "android_download"} />
                </div>
              </a>
            </div>
            {showDownloadHint && <DownloadHint callback={onDownloadHintCallback} />}
          </div>
        </div>
      </div>
    </div>
  );
};

OutsideDownloadContainer.getInitialProps = async () => {
  return { isMultiLanguage: true }
};

export default OutsideDownloadContainer;
